import { default as Header } from './header';

export default Header;
